import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { User, AuthenticationResponse } from '../../../models/ui/User';
import { AuthService } from '../../services';
import { LookupService } from 'src/app/services/Lookup/lookup.service';
import notify from 'devextreme/ui/notify';

@Component({
  selector: 'app-password-form',
  templateUrl: './password-form.component.html',
  styleUrls: ['./password-form.component.css']
})
export class PasswordFormComponent implements OnInit {
  ngOnInit() {

  }
  
  userDetails: User;
  userRole: string;
  currentUserRole: string;
  authenticationResponse: string;

  constructor(private router: Router, private authService: AuthService, private lookupService: LookupService) {
      this.userDetails = new User();
  }

  login(args) {
    if (!args.validationGroup.validate().isValid) {
      return;
    }

    this.authService.checkUserDetails(this.userDetails).subscribe(data => this.authenticationResponse = data);
    if(this.authenticationResponse != null) {
        //localStorage.setItem("UserID", this.authenticationResponse.UserID);
        
        this.currentUserRole = localStorage.getItem("UserRole");

        this.lookupService.getUserRole(this.userDetails).subscribe(data => this.userRole = data);

        setTimeout(() => {
          if(this.currentUserRole != this.userRole)
          {
            localStorage.setItem("UserRole", this.userRole);
            localStorage.setItem("reloadPage", "true");
          }
          localStorage.setItem("isAuthorized", "true");
          this.router.navigate(['/home']);
        }, 1500);
    } else
        notify("Incorrect username or password.");

        args.validationGroup.reset();
  }
}